module.exports = __webpack_public_path__ + "img/lg_ring_y_s_null_1@3x.3eec3289.png";